import Fields from 'components/Fields';
import { Field } from 'formik';
import React, { Fragment } from 'react';
import { FoundFundProp } from './types';
interface FoundsFundsProps {
  foundFunds: FoundFundProp[];
  classes: any;
}

const FoundFunds = ({ foundFunds, classes }: FoundsFundsProps) => {
  return (
    <Fragment>
      {foundFunds.length !== 0 && (
        <div className={classes.title}>Found Funds</div>
      )}
      {foundFunds.map((found: any, i: number) => {
        return (
          <div
            key={`found${i}`}
            className={classes.foundRow}
            style={{
              backgroundColor: i % 2 === 0 ? '#f9f9f9' : 'white'
            }}
          >
            <div className={classes.code}>{found.code}</div>
            <div className={classes.nameAndCheckbox}>
              <div className={classes.result}>{found.result.name}</div>
              <Field
                component={Fields.v2.Checkbox}
                name={`imports.found[${i}].isSelected`}
              />
            </div>
          </div>
        );
      })}
    </Fragment>
  );
};

export default FoundFunds;
